import type { IFaqCategory } from './faq-types';

export const faqGeneral: IFaqCategory = {
  title: 'General',
  slug: 'general',
  items: [
    {
      question: 'What is Cool Mate?',
      answer:
        'Cool Mate is an English learning app that helps you grow your skills through real-world content from movies, shows, and everyday conversations. Lessons include subtitles, vocabulary highlights, and comprehension exercises to build listening and speaking skills naturally.',
    },
    {
      question: 'Who is the app for?',
      answer:
        'Anyone who wants to improve their English. Cool Mate is designed for self-study, from beginners to advanced learners, especially non-native speakers looking to learn from real content.',
    },
    {
      question: 'Is the app free?',
      answer:
        'Cool Mate offers free starter content. Full access to all features and the complete content library is unlocked through a subscription or a one-time lifetime purchase via the App Store or Google Play.',
    },
    {
      question: 'Does the app require internet?',
      answer:
        'Yes, Cool Mate currently requires an internet connection to load content and sync your progress. Offline support is planned for a future update.',
    },
    {
      question: 'What platforms is Cool Mate available on?',
      answer:
        'Cool Mate is available on iOS (iPhone and iPad) and Android. There is also an Apple Watch companion app for quick reviews on the go.',
    },
  ],
};
